// extracted by mini-css-extract-plugin
export default {"emptyStateContainer":"NGP8","bodyText":"Esfl","additionalText":"oxoD","buttonsContainer":"__dY","svgFillWhite":"IKHi","bottomLinkContainer":"itpY"};